export const HSBC_APP_LINK =
  "https://www.hsbc.com.sg/configuration/mobile-app-redirect/";

export const HSBC_PORTAL_NAME = "hsbc-portal";

export enum HsbcPortalComponent {
  PremierDestinationQuickPicks = "PremierDestinationQuickPicks",
}
